import { categories } from '@/mocks/motionComics';

export default function Categories() {
  return (
    <section id="categories" className="bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="mx-auto max-w-2xl text-center">
          <span className="text-xs font-medium tracking-widest text-primary-400">GENRES</span>
          <h2 className="mt-3 font-heading text-2xl text-foreground-50 md:text-4xl">按口味精准挑选</h2>
          <p className="mt-3 text-sm leading-7 text-foreground-300">
            六大热门分类覆盖主流追更口味，找到你的心头好，一头扎进全彩动态漫画的世界。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2 md:gap-5 lg:grid-cols-3">
          {categories.map((c) => (
            <a
              key={c.name}
              href={`#featured`}
              className="card-lift group relative block h-52 overflow-hidden rounded-lg border border-background-300/50"
            >
              <img
                src={c.image}
                alt={`${c.name} 类型动态漫画`}
                title={`${c.name} 韩国动态漫画分类`}
                className="h-full w-full object-cover object-center transition-transform duration-500 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-transparent"></div>
              <div className="absolute inset-x-0 bottom-0 p-4 md:p-5">
                <div className="flex items-center justify-between">
                  <h3 className="font-heading text-xl text-foreground-50">{c.name}</h3>
                  <span className="whitespace-nowrap rounded-full bg-accent-500 px-2.5 py-0.5 text-xs font-semibold text-background-950">
                    {c.count} 部
                  </span>
                </div>
                <p className="mt-1.5 text-xs text-foreground-200">{c.desc}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}